import { api } from '../../api'

export const deleteCreatorService = async (creatorId: string) => {
  await api.delete(`/api/backoffice/creators/${creatorId}`)
}
